import React, { useContext, useEffect, useState, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import HistoryIcon from "@mui/icons-material/History";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import _ from "lodash";

import api from "../../BrandOnBoarding/api";
import LLM from "./LLM";
import classes from "./PromptEngine.module.css";
import Summary from "./Summary/Summary";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import Modal from "./../../Component/Modal/Modal";
import History from "./History/History";
import { AuthContext } from "../../context/auth-context";
import Form from "./Form";


// Important - Do not change id's in below LLMs. Changing IDs will break history loading for existing conversations
const LLMs = [
  // {
  //   id: 1,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-4o-Offline",
  //   model: "gpt-4o",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 2,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-4o-Search-Enabled",
  //   model: "gpt-4o-web-search",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },

  // {
  //   id: 3,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5-Offline",
  //   model: "gpt-5",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 9,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5-Search-Enabled",
  //   model: "gpt-5-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 21,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.4-Offline",
  //   model: "gpt-5.4",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 22,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.4-Search-Enabled",
  //   model: "gpt-5.4-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 27,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.5-Offline",
  //   model: "gpt-5.5",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 28,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.5-Search-Enabled",
  //   model: "gpt-5.5-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  {
    id: 31,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "GPT-5.6-Offline",
    model: "gpt-5.6",
    isActive: true,
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 32,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "GPT-5.6-Search-Enabled",
    model: "gpt-5.6-search-enabled",
    isActive: true,
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  // {
  //   id: 41,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-6-Offline",
  //   model: "gpt-6",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 42,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-6-Search-Enabled",
  //   model: "gpt-6-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  {
    id: 41,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "GPT-6.1-Offline",
    model: "gpt-6.1",
    isActive: true,
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 42,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "GPT-6.1-Search-Enabled",
    model: "gpt-6.1-search-enabled",
    isActive: true,
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  // {
  //   id: 23,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Claude-4.6",
  //   model: "Claude-4.6",
  //   isActive: true,
  //   img: "/claude-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "assistant",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 24,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Claude-4.6-Search-Enabled",
  //   model: "Claude-4.6-Search",
  //   isActive: true,
  //   img: "/claude-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "assistant",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  {
    id: 29,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Claude-5",
    model: "Claude-5",
    isActive: true,
    img: "/claude-logo.png",
    text: "",
    messages: [
      {
        role: "assistant",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 30,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Claude-5-Search-Enabled",
    model: "Claude-5-Search",
    isActive: true,
    img: "/claude-logo.png",
    text: "",
    messages: [
      {
        role: "assistant",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 44,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Claude-5.5",
    model: "Claude-5.5",
    isActive: true,
    img: "/claude-logo.png",
    text: "",
    messages: [
      {
        role: "assistant",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 43,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Claude-5.5-Search-Enabled",
    model: "Claude-5.5-Search",
    isActive: true,
    img: "/claude-logo.png",
    text: "",
    messages: [
      {
        role: "assistant",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  // {
  //   id: 19,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.2-Offline",
  //   model: "gpt-5.2",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 20,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.2-Search-Enabled",
  //   model: "gpt-5.2-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 12,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.1-Chat-Offline",
  //   model: "gpt-5.1-chat",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 13,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "GPT-5.1-Chat-Search-Enabled",
  //   model: "gpt-5.1-chat-search-enabled",
  //   isActive: true,
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 15,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Gemini-3.0",
  //   model: "Gemini-3.0",
  //   isActive: true,
  //   img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
  //   text: "",
  //   messages: [
  //     {
  //       role: "model",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 16,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Gemini-3.0-Search",
  //   model: "Gemini-3.0-Search",
  //   isActive: true,
  //   img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 25,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Gemini-3.1",
  //   model: "Gemini-3.1",
  //   isActive: true,
  //   img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
  //   text: "",
  //   messages: [
  //     {
  //       role: "model",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 26,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Gemini-3.1-Search",
  //   model: "Gemini-3.1-Search",
  //   isActive: true,
  //   img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  {
    id: 39,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Gemini-3.8-Flash",
    model: "Gemini-3.8-Flash",
    isActive: true,
    img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
    text: "",
    messages: [
      {
        role: "model",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 40,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Gemini-3.8-Flash-Search",
    model: "Gemini-3.8-Flash-Search",
    isActive: true,
    img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  // {
  //   id: 26,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Gemini-3.1-Search",
  //   model: "Gemini-3.1-Search",
  //   isActive: true,
  //   img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
//   {
//     id: 4,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
//     name: "Gemini-2.5",
//     model: "GeminiV25",
//     isActive: true,
//     img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
//     text: "",
//     messages: [
//       {
//         role: "model",
//         content: "Hello! How can I assist you today?",
//       },
//     ],
//   },
//   {
//     id: 10,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
//       name: "Gemini-2.5-Search",
//       model: "GeminiV25Search",
//       isActive: true,
//       img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
//       text: "",
//       messages: [
//           {
//  role: "system",
//             content: "Hello! How can I assist you today?",
//           },
//     ],
//   },
  // {
  //   id: 17,
  //   name: "Grok-4.1-Offline",
  //   model: "grok-4-1",
  //   isActive: true,
  //   img: "/grok-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 18,
  //   name: "Grok-4.1-Search-Enabled",
  //   model: "grok-4-1-web-search",
  //   isActive: true,
  //   img: "/grok-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 33,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Grok-4.5-Offline",
  //   model: "grok-4.5",
  //   isActive: true,
  //   img: "/grok-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 34,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Grok-4.5-Search-Enabled",
  //   model: "grok-4.5-web-search",
  //   isActive: true,
  //   img: "/grok-logo.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  {
    id: 45,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Grok-4.7-Offline",
    model: "grok-4.7",
    isActive: true,
    img: "/grok-logo.png",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  {
    id: 46,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
    name: "Grok-4.7-Search-Enabled",
    model: "grok-4.7-search-enabled",
    isActive: true,
    img: "/grok-logo.png",
    text: "",
    messages: [
      {
        role: "system",
        content: "Hello! How can I assist you today?",
      },
    ],
  },
  // {
  //   id: 5,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Claude-4.0",
  //   model: "Claude4",
  //   isActive: true,
  //   img: "https://claude.ai/images/claude_app_icon.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "assistant",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 14,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Claude-4.5",
  //   model: "Claude-4.5",
  //   isActive: true,
  //   img: "https://claude.ai/images/claude_app_icon.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "assistant",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 11,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Claude-4.5-Search-Enabled",
  //   model: "Claude-4.5-Search",
  //   isActive: true,
  //   img: "https://claude.ai/images/claude_app_icon.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "assistant",
  //       content: "Hello! How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 8,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Llama-3",
  //   model: "llama3",
  //   isActive: true,
  //   img: "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_5351a237b4bf5239e06d7775686837ea/meta-llama-3.png",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 6,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "Perplexity-Search-Enabled (sonar)",
  //   model: "Perplexity",
  //   isActive: true,
  //   img: "https://mintlify.s3-us-west-1.amazonaws.com/perplexity/_generated/favicon/favicon-32x32.png?v=3",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello How can I assist you today?",
  //     },
  //   ],
  // },
  // {
  //   id: 7,  // ⚠️ DO NOT CHANGE - id. Changing breaks old conversation history.
  //   name: "DeepSeek (Together)",
  //   model: "deepseek_together",
  //   isActive: true,
  //   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqKHD28rGat3WVaqRkRDgIL-SHgOTHB6MrNg&s",
  //   text: "",
  //   messages: [
  //     {
  //       role: "system",
  //       content: "Hello How can I assist you today?",
  //     },
  //   ],
  // },
];

export default function Dashboard() {
  const [messageList, setMessageList] = useState(_.cloneDeep(LLMs));
  const [userPrompt, setUserPrompt] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [isExistingChat, setIsExistingChat] = useState(false);
  const [conversationId, setConversationId] = useState(null);

  const { user } = useContext(AuthContext);
  const dataArrivedRef = useRef(false);

  const {
    launchText,
    hoverText,
    launchesRemaining,
    updateLaunches,
    isSpecial,
    frequency: launchLimitFrequency,
  } = useDailyLimits("PromptEngine");

  const { pathname } = useLocation();

  const timeoutsRef = useRef({});
  const TIMEOUT_DEFAULT = 60 * 1000;


  function getTimeoutForModel(llm) {
    if (!llm || !llm.model) return TIMEOUT_DEFAULT;
    return TIMEOUT_DEFAULT;
  }

  function clearLLMTimeout(llmName) {
    const t = timeoutsRef.current[llmName];
    if (t) {
      clearTimeout(t);
      delete timeoutsRef.current[llmName];
    }
  }

  async function getConversationName(messageList) {
    let firstConversation = messageList[0].slice(messageList[0].length - 2);
    let message = ``;
    firstConversation.forEach((item, index) => {
      message += `Message ${index + 1}: ${item.content}\n`;
    });

    const prompt = `Based on these two messages. Name this conversation in 3 to 5 words
      ${message}
      Provide response in following JSON format
      {
        data: NAME_OF_CONVERSATION (string)
      }
    `;

    const payload = {
      llm: "gpt-4o",
      prompt: prompt,
    };
    const response = await api.post("/llm-execute", payload);

    return response.data.data.data;
  }

  async function createNewConversation(messageList) {
    const activeLLMs = messageList.filter((llm) => llm.isActive);  // ✅ Keep full LLM objects

    const title = await getConversationName(
      activeLLMs.map((llm) => llm.messages)
    );

    const response = await api.post("/llm-conversations", {
      userId: user.id,
      title: title,
    });
    setConversationId(response.data.mainConversation.id);
    setConversations(response.data.subConversations);
    const subConvo = response.data.subConversations;

    prepareAndStoreMessages(activeLLMs, subConvo);  // ✅ Pass LLM objects with IDs
  }

  async function prepareAndStoreMessages(activeLLMs, subConvo) {
    if (!subConvo.length) return;
    const conversations = [];

    activeLLMs.forEach((llm, index) => {  // ✅ Now receives LLM objects
      conversations.push({
        id: subConvo[index].id,
        messages: llm.messages.map((msg) => {
          return {
            aiAssistantId: llm.id,  // ✅ FIXED: Using llm.id
            isUserMessage: msg.role === "user",
            content: msg.content,
          };
        }),
      });
    });

    for (let i = 0; i < conversations.length; i++) {
      await addNewMessage(conversations[i].id, {
        messages: conversations[i].messages,
      });
    }
  }

  function addNewMessage(id, payload) {
    return api.post(`/llm-conversations/${id}`, payload);
  }

  useEffect(() => {
    resetConversation();
  }, [pathname]);

  const handleSend = (e) => {
    e.preventDefault();
    if (launchesRemaining <= 0 && !isSpecial) {
      toast.warn(`You have reached your ${launchLimitFrequency} limit`);
      return;
    }

    if (!userPrompt) {
      toast.warn("Please enter query");
      return;
    }

    if (!isSpecial) updateLaunches();
    setLoading(true);

    const newMessageList = _.cloneDeep(messageList);

    newMessageList.forEach((llm) => {
      if (llm.isActive) {
        llm.messages.push({
          id: crypto.randomUUID(),
          role: "user",
          content: userPrompt,
        });
      }
    });
    setMessageList(newMessageList);
    setUserPrompt("");
    dataArrivedRef.current = false;

    newMessageList.forEach((llm) => {
      if (llm.isActive) {
        // clear any previous timer
        clearLLMTimeout(llm.name);

        const TIMEOUT_MS = getTimeoutForModel(llm);
        timeoutsRef.current[llm.name] = setTimeout(() => {
          // inject synthetic assistant message if not answered
          setMessageList((prev) => {
            const copy = _.cloneDeep(prev);
            const idx = copy.findIndex((x) => x.name === llm.name);
            if (idx === -1) return prev;

            const last = copy[idx].messages[copy[idx].messages.length - 1];
            const alreadyAnswered = last && last.role === "assistant";

            if (!alreadyAnswered) {
              copy[idx].messages.push({
                id: `timeout-${Date.now()}-${llm.name}`,
                role: "assistant",
                content: `Timeout: no response from ${llm.name} after ${Math.round(TIMEOUT_MS / 1000)}s.`,
                __isTimeout: true, // marker so we can replace it later
              });
            }
            return copy;
          });

          delete timeoutsRef.current[llm.name];
        }, TIMEOUT_MS);
      }
    });

  };

  function resetConversation() {
    if (isLoading) return;
    setMessageList(_.cloneDeep(LLMs));
    setConversationId(null);
    setConversations([]);
  }

  // function handleMessageReceived(llmName, message) {
  //   const newMessageList = [...messageList];
  //   const llmIndex = newMessageList.findIndex((llm) => llm.name === llmName);
  //   newMessageList[llmIndex].messages.push(message);
  //   setMessageList(newMessageList);
  // }

  function handleMessageReceived(llmName, message) {
    // clear timer
    clearLLMTimeout(llmName);

    setMessageList((prev) => {
      const copy = _.cloneDeep(prev);
      const idx = copy.findIndex((l) => l.name === llmName);
      if (idx === -1) return prev;

      // If last message is our synthetic timeout, replace it
      const lastIdx = copy[idx].messages.length - 1;
      const last = copy[idx].messages[lastIdx];
      if (last && last.__isTimeout) {
        copy[idx].messages[lastIdx] = { ...message };
      } else {
        copy[idx].messages.push(message);
      }
      return copy;
    });
  }

  useEffect(() => {
    return () => {
      Object.values(timeoutsRef.current).forEach((t) => clearTimeout(t));
      timeoutsRef.current = {};
    };
  }, []);



  function historyItemSelectHandler(item) {
    setConversationId(item.id);
    setIsExistingChat(true);
    setConversations(item.subConversations.map((i) => ({ id: i.id })));
    setMessageList((previousList) => {
      let updatedList = _.cloneDeep(previousList);
      updatedList.map((list) => {
        const subConvo = item.subConversations.find((conv) => {
          return (
            conv?.llm_messages.length > 0 &&
            conv.llm_messages[0].ai_assistant_id === list.id
          );
        });
        if (!subConvo) return;
        list.messages = subConvo.llm_messages.map((msg, index) => {
          return {
            id: msg.id,
            role: msg.is_user_message
              ? "user"
              : index == 0
                ? msg.ai_assistant_id === 3
                  ? "assistant"
                  : "system"
                : "assistant",
            content: msg.content,
          };
        });
      });
      updatedList = updatedList.map((o) =>
        o.messages.length === 1 ? { ...o, isActive: false } : o
      );
      return updatedList;
    });
    setShowHistory(false);
  }

  const messages = messageList
    .filter((eachMessage) => eachMessage.isActive)
    .map((list) => list.messages);

  useEffect(() => {
    if (messages.every((msg) => msg.length === 0)) {
      setLoading(false);
      return;
    }
    const isDataArrived = messages.every(
      (msgs) => msgs.length > 0 && msgs[msgs.length - 1].role === "assistant"
    );
    if (isDataArrived && !dataArrivedRef.current) {
      dataArrivedRef.current = true;
      if (
        messages.every((list) => list.length === 3) &&
        conversations.length === 0
      ) {
        createNewConversation(messageList);
      } else if (!isExistingChat) {
        // ✅ Get active LLMs with their IDs
        const activeLLMs = messageList.filter((llm) => llm.isActive);

        // ✅ Create new array with just recent messages but keep llm.id
        const recentMessagesLLMs = activeLLMs.map((llm) => ({
          ...llm,
          messages: llm.messages.slice(llm.messages.length - 2)
        }));

        prepareAndStoreMessages(recentMessagesLLMs, conversations);  // ✅ Pass LLM objects
      }
      if (isExistingChat) {
        setIsExistingChat(false);
      }

      setLoading(false);
    }
  }, [messages]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <ToastContainer />
        <Modal
          title="History"
          width={800}
          height="70%"
          open={showHistory}
          handleClose={() => setShowHistory(false)}
          handleConfirm={() => setShowHistory(false)}
        >
          <History
            onItemSelected={historyItemSelectHandler}
            onDelete={resetConversation}
          />
        </Modal>
        <div className={classes.header}>
          <div>
            <MUIButton
              className={classes.history}
              variant="outlined"
              startIcon={<DriveFileRenameOutlineOutlinedIcon />}
              onClick={resetConversation}
            >
              New Chat
            </MUIButton>
            <span>&nbsp;</span>
            <MUIButton
              className={classes.history}
              variant="outlined"
              startIcon={<HistoryIcon />}
              onClick={() => {
                resetConversation();
                setShowHistory(true);
              }}
            >
              History
            </MUIButton>
          </div>
          {hoverText ? (
            <Tooltip title={hoverText} placement="bottom-end" arrow>
              <span className={classes.action_txt} style={{ cursor: "default" }}>{launchText}</span>
            </Tooltip>
          ) : (
            <span className={classes.action_txt}>{launchText}</span>
          )}
        </div>
        <Form
          onSubmit={handleSend}
          prompt={userPrompt}
          isLoading={isLoading}
          setPrompt={(val) => setUserPrompt(val)}
        />

        <div className="container-fluid">
          <div className={`${classes.grid} row`}>
            {messageList.map((llm) => (
              <LLM
                key={llm.name}
                llm={llm}
                setMessageList={setMessageList}
                onMessage={handleMessageReceived}
              />
            ))}
          </div>
        </div>
      </div>

      <Summary
        messages={messageList.map((list) => ({
          msgs: list.messages,
          llm: list.name,
        }))}
        conversationId={conversationId}
        enabled={conversations.length > 0}
        loading={isLoading}
      />
    </div>
  );
}
